import * as UIToolkit from '../../../UIToolkit/index';

// 渲染层板放置区域宽高
export function setShelfDropAreaStyle(cube: CubeNode): void {
    let height: number = UIToolkit.getPXSizeValue(cube.id, 'height');
    let width: number = UIToolkit.getPXSizeValue(cube.id, 'width');

    cube.jView.find('.J_ElementBoxSlot').css({
        left: '',
        top: '',
        width: `${width}px`,
        height: `${height}px`
    });
}
